'use strict';

/**
 * @classname BtnSearch
 * @classdesc 検索ボタン
 */
export default class BtnSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - .btn--search
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$input = $e.parent('.block').find('input');
		this._$input.on('focus', () => {
			this._$input.addClass('focused');
		});
		this._$input.on('blur', () => {
			this._$input.removeClass('focused');
		});
		$(window).on('keypress', (e) => this.checkKeyword(e));
		$e.on('click', () => this.submit());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof BtnSearch
	 * @return undefined
	 */
	submit() {
		console.log(`${this.constructor.name}.submit`);
		const value = this._$input.val();
		if(value !== ''){
			location.href = `${window.const.URL.SEARCH}?keyword=${value}`;
		}
	};


	/**
	 * keypressのコールバック
	 *
	 * @memberof BtnSearch
	 * @return undefined
	 */
	checkKeyword(e) {
		console.log(`${this.constructor.name}.checkKeyword`);
		console.log(e.key);
		console.log(this._$input[0]);
		console.log(document.activeElement);
		if(e.key === 'Enter' && this._$input.hasClass('focused')) this.submit();
	};
};
